<template>
    <v-card fluid>
        <v-card-title>
            <v-row cols="12" dense>
                <v-col cols="1"><btn_component data="" type="text" icon="mdi-keyboard-backspace" text="Back" tooltip="Back to list" size="small" @actionClick="viewAll" v-if="allowBack"/></v-col>
                <v-col cols="8"><h2>{{ this.title }}</h2></v-col>
                <v-col cols="1"><btn_component data="" type="text" :text="remark_txt" :tooltip="remark_tip" :color="remark_color" :disabled="remark_copy!==question.oavr_opm_intern" size="small" @actionClick="remarkAction(!remark_hide)"/></v-col>
                <v-col cols="1"><btn_component data="" type="text" text="Preferred Q&A" tooltip="Preferred questions and answers" size="small" @actionClick="preferredQuestions"/></v-col>
                <v-col cols="1"></v-col>
            </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row cols="12" dense v-if="!remark_hide">
                <v-col cols="1">Remark</v-col>
                <v-col cols="10"><v-textarea rows="6" v-model="question.oavr_opm_intern" variant="outlined" outlined></v-textarea></v-col>
                <v-col cols="1" v-if="remark_copy!==question.oavr_opm_intern">
                    <btn_component data="" type="text" text="Save" tooltip="Save internal remark" color="primary" size="small" @actionClick="saveRemark"/>
                    <br><br>
                    <btn_component data="" type="text" text="Undo" tooltip="Restore internal remark" color="warning" size="small" @actionClick="undoRemark"/>
                </v-col>
            </v-row>
            <v-row cols="12" dense>
                <v-col cols="1" class="pt-4">Source</v-col>
                <v-col cols="1" class="pt-4">{{ question.oavr_bron }}</v-col>
                <v-col cols="1" class="pt-4">Category</v-col>
                <v-col cols="2"><v-select v-model="question.oact_code" :items="categories" item-value="Option" item-text="Description" label="Category" readonly dense @change="saveCategory"></v-select></v-col>
                <v-col cols="2" class="pt-4" v-if="question.oavr_tabel==='huov'">Booking
                    <b><span class="houvlink" @click="$router.open('/huov/onHuov/' + question.huov_encrid)">{{ question.oavr_key }}</span></b> / 
                    <b><span class="houvlink" @click="$router.open('/huis/onHuis/' + question.huis_encrid)">{{ question.huis_code }}</span></b>
                </v-col>
                <v-col cols="1" class="pt-4" v-if="question.oavr_tabel==='huis'">Accommodation</v-col>
                <v-col cols="1" class="pt-4" v-if="question.oavr_tabel==='huis'"><b>{{ question.oavr_key }}</b></v-col>
                <v-col cols="2" class="pt-4">Date submitted: {{ question.oavr_received_dt.replace("T", " ").substring(0, 16) }}</v-col>
            </v-row>
            <v-row cols="12" dense>
                <v-col cols="1">Question</v-col>
                <v-col cols="10"><v-textarea rows="4" v-model="question_current" variant="outlined" readonly outlined></v-textarea></v-col>
                <v-col cols="1">
                    <btn_component data="" type="text" text="Translate" tooltip="Translate the question" size="small" @actionClick="translateQuestion"/>
                    <br><br>
                    <btn_component data="" type="text" :text="question_view_txt" :tooltip="question_view_tip" size="small" @actionClick="setupQuestion(!question_view_org)" v-if="question_translation!==''"/>
                </v-col>
            </v-row>
            <v-row cols="12" dense>
                <v-col cols="1"></v-col>
                <v-col cols="1">
                    <btn_component data="" type="text" :text="hide_txt" :tooltip="hide_tip" size="small" @actionClick="toggleField"/>
                </v-col>
                <v-col cols="3">To {{ question.oavr_antw_zend_methode }}</v-col>
                <v-col cols="1">Rating: <b>{{ question.oavr_rating_oms }}</b></v-col>
                <v-col cols="3"><div v-if="question.oavr_rating==='Rejected'">Reason <b>{{ question.oavr_reject_oms }}</b></div></v-col>
            </v-row>
            <v-row cols="12" dense v-if="!hide">
                <v-col cols="1">Chat GPT</v-col>
                <v-col cols="10"><v-textarea v-model="answer_org_current" :rows=8 readonly variant="outlined" outlined></v-textarea></v-col>
                <v-col cols="1">
                    <btn_component data="" type="text" text="Translate" tooltip="Translate the answer" size="small" @actionClick="translateAnswer"/>
                    <br><br>
                    <btn_component data="" type="text" :text="answer_org_view_txt" :tooltip="answer_org_view_tip" size="small" @actionClick="setupAnswer(!answer_org_view_org)" v-if="answer_org_translation!==''"/>
                </v-col>
            </v-row>
            <v-row cols="12" dense>
                <v-col cols="1">Manual</v-col>
                <v-col cols="10"><v-textarea v-model="question.oavr_antwoord_def" :rows=10 variant="outlined" :readonly="completed" outlined></v-textarea></v-col>
                <v-col cols="1">
                    <btn_component data="" type="text" text="Translate" tooltip="Translate the manually changed answer" size="small" @actionClick="translateAnswerDef"/>
                    <br><br>
                    <btn_component data="" type="text" icon="mdi-content-copy" text="Copy" tooltip="copy answer to clipboard" size="small" @actionClick="copyAnswer"/>
                </v-col>
            </v-row>
            <v-row cols="12" dense>
                <v-col cols="1"></v-col>
                <v-col cols="10">
                    <div v-if="question.oavr_antwoord_org===answer_def_copy">The text has not been adjusted</div>
                    <div class="warning" v-if="question.oavr_antwoord_org!==answer_def_copy">The text has been adjusted manually</div>
                </v-col>
                <v-col cols="1"></v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-row cols="12" class="pt-0 pb-2" dense>
                <v-col cols="1">
                </v-col>
                <!-- <btn_component class="px-2" data="" type="text" text="Send answer" tooltip="Send answer to belco / guest" size="small" @actionClick="completeQuestion"/> -->
                <btn_component class="px-2" data="" type="text" text="Accept" tooltip="Accept the (modified) answer" size="small" @actionClick="acceptAnswer" v-if="answer_def_copy===question.oavr_antwoord_def&&!completed"/>
                <btn_component class="px-2" data="" type="text" text="Reject" tooltip="Reject the answer" size="small" @actionClick="rejectAnswer" v-if="answer_def_copy===question.oavr_antwoord_def&&!completed"/>
                <btn_component class="px-2" data="" type="text" text="Resubmit" tooltip="Resubmit the question" size="small" @actionClick="resubmitQuestion" v-if="answer_def_copy===question.oavr_antwoord_def&&maintenance"/>
                <v-spacer></v-spacer>
                <btn_component class="px-2" data="" type="text" text="Undo changes" tooltip="Undo current changes" size="small" @actionClick="undoChanges" v-if="answer_def_copy!==question.oavr_antwoord_def"/>
                <!-- <btn_component class="px-2" data="" type="text" text="Save reason" tooltip="Update the reason" size="small" @actionClick="saveReason" v-if="reason_copy!==question.oavr_reject_oms"/> -->
                <btn_component class="px-2" data="" type="text" text="Save changes" tooltip="Update the answer" size="small" @actionClick="saveAnswer" v-if="answer_def_copy!==question.oavr_antwoord_def"/>
                <btn_component class="px-2" data="" type="text" text="Delete question" tooltip="Delete (test) question" color="error" size="small" @actionClick="deleteQuestion" v-if="answer_def_copy===question.oavr_antwoord_def&&maintenance"/>
                <v-col cols="1">
                </v-col>
            </v-row>
        </v-card-actions>
        <question_accept ref="question_accept" @updateAction="updateAction"/>
        <question_reject ref="question_reject" @updateAction="updateAction"/>
        <question_resubmit ref="question_resubmit" @updateAction="updateAction"/>
        <question_delete ref="question_delete" @updateAction="updateAction"/>
        <translate_text ref="translate_text" @updateAction="updateAction"/>
    </v-card>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import question_accept from "@/components/task/customer_success/openai/question_accept.vue";
    import question_reject from "@/components/task/customer_success/openai/question_reject.vue";
    import question_resubmit from "@/components/task/customer_success/openai/question_resubmit.vue";
    import question_delete from "@/components/task/customer_success/openai/question_delete.vue";
    import translate_text from "@/components/task/customer_success/openai/translate_text.vue";

    export default {
        components: {
            btn_component,
            question_accept,
            question_reject,
            question_resubmit,
            question_delete,
            translate_text,
        },    
        props: {
            oavr_nr: {
                type: Number,
                required: true,
            }
        },
        data() {
            return {
                title: "Pending question details",
                categories: [],
                ratings: [],
                question: {
                    oavr_reject_oms: "",
                    oavr_antwoord_org: "",
                    oavr_antwoord_def: "",
                    oavr_received_dt: "",
                },

                question_current: "",
                question_translation: "",
                question_view_org: true,
                question_view_txt: "Translated",
                question_view_tip: "View tranlated question",

                answer_org_current: "",
                answer_org_translation: "",
                answer_org_view_org: true,
                answer_org_view_txt: "Translated",
                answer_org_view_tip: "View tranlated answer",

                answer_def_copy: "",
                //answer_def_current: "",
                //answer_def_translation: "",
                //answer_def_view_org: true,
                //answer_def_view_txt: "Translated",
                //answer_def_view_tip: "View tranlated answer",

                reason_copy: "",

                hide_txt: "Hide chatGPT",
                hide_tip: "Hide chatGPT answer",
                hide: false,

                remark_copy: "",
                remark_txt: "Add remark",
                remark_tip: "Add internal remark",
                remark_color: "primary",
                remark_hide: true,

                maintenance: false,
            }
        },    
        mounted() {
            this.getQuestionDetails();
        },
        computed: {
            completed: function() {
                if (this.question.oavr_rating === "NoRating") {
                    return false;
                }
                return true;
            },
            allowBack: function() {
                if (this.answer_def_copy!==this.question.oavr_antwoord_def) return false;
                if (this.reason_copy!==this.question.oavr_reject_oms) return false;
                if (this.remark_copy!==this.question.oavr_opm_intern) return false;
                return true;
            }
        },
        methods: {     
            viewAll() {
                this.$emit("updateView", 0);
            },
            getQuestionDetails() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/getQuestionDetails.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getQuestionDetails"
                    },
                    getQuestionDetails: {
                        oavr_nr: this.oavr_nr,
                    }
                }).then(res => {
                    if (res.data.header.error) {
                        console.log(res.data.error);
                    } else {
                        this.question = res.data.getQuestionDetails;

                        this.categories = res.data.oact;
                        this.ratings = res.data.rating_codes;

                        this.question_translation = "";
                        this.answer_org_translation = "";

                        this.answer_def_copy = this.question.oavr_antwoord_def;
                        this.reason_copy = this.question.oavr_reject_oms;
                        this.remark_copy = this.question.oavr_opm_intern;
                        this.maintenance = res.data.maintenance;

                        this.setupQuestion(true);
                        this.setupAnswer(true);
                        this.setupAnswerDef();
                        this.remarkAction(this.question.oavr_opm_intern === '');
                    }
                });
            },
            setupQuestion(showOriginal) {
                this.question_view_org = showOriginal;
                if (this.question_view_org) {
                    this.question_current = this.question.oavr_vraag;
                    this.question_view_txt = "Translated";
                    this.question_view_tip = "View tranlated question";
                } else {
                    this.question_current = this.question_translation;
                    this.question_view_txt = "Original";
                    this.question_view_tip = "View original question";
                }
            },
            translateQuestion() {
                this.$refs.translate_text.openDialog(this.question.oavr_vraag, this.question_translation, this.question.oavr_vraag, "question_translation");
            },
            setupAnswer(showOriginal) {
                this.answer_org_view_org = showOriginal;
                if (this.answer_org_view_org) {
                    this.answer_org_current = this.question.oavr_antwoord_org;
                    this.answer_org_view_txt = "Translated";
                    this.answer_org_view_tip = "View tranlated answer from chatGPT";
                } else {
                    this.answer_org_current = this.answer_org_translation;
                    this.answer_org_view_txt = "Original";
                    this.answer_org_view_tip = "View original answer from chatGPT";
                }
            },
            translateAnswer() {
                this.$refs.translate_text.openDialog(this.question.oavr_antwoord_org, this.answer_org_translation, this.question.oavr_vraag, "answer_org_translation");
            },
            setupAnswerDef() {
                this.answer_def_current = this.question.oavr_antwoord_def;
            },
            translateAnswerDef() {
                this.$refs.translate_text.openDialog(this.question.oavr_antwoord_def, "", this.question.oavr_vraag, "oavr_antwoord_def");
            },
            copyAnswer() {
                navigator.clipboard.writeText(this.question.oavr_antwoord_def);
                this.$store.dispatch("setSnackbar", {
                    showing: true,
                    text: "Answer copied to clipboard.",
                    color: "success"
                });
            },
            saveAnswer() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/saveQuestionAnswer.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveQuestionAnswer"
                    },
                    saveQuestionAnswer: {
                        oavr_encrid: this.question.oavr_encrid,
                        oavr_antwoord_def: this.question.oavr_antwoord_def,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveQuestionAnswer.text,
                            color: res.data.saveQuestionAnswer.color
                        });
                        this.answer_def_copy = this.question.oavr_antwoord_def;
                    }
                });
            },
            saveReason() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/saveRejectReason.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveRejectReason"
                    },
                    saveRejectReason: {
                        oavr_encrid: this.question.oavr_encrid,
                        oavr_reject_oms: this.question.oavr_reject_oms,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveRejectReason.text,
                            color: res.data.saveRejectReason.color
                        });
                        this.reason_copy = this.question.oavr_reject_oms;
                    }
                });
            },
            undoChanges() {
                this.question.oavr_antwoord_def = this.answer_def_copy;
                this.question.oavr_reject_oms = this.reason_copy;
            },
            saveCategory() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/saveQuestionCategory.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveQuestionCategory"
                    },
                    saveQuestionCategory: {
                        oavr_encrid: this.question.oavr_encrid,
                        oact_code: this.question.oact_code,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveQuestionCategory.text,
                            color: res.data.saveQuestionCategory.color
                        });
                        this.question.oact_oms = res.data.saveQuestionCategory.oms
                    }
                });
            },
            saveRating() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/saveQuestionRating.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveQuestionRating"
                    },
                    saveQuestionRating: {
                        oavr_encrid: this.question.oavr_encrid,
                        oavr_rating: this.question.oavr_rating,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveQuestionRating.text,
                            color: res.data.saveQuestionRating.color
                        });
                        this.question.oavr_rating_oms = res.data.saveQuestionRating.oms
                        this.question.oavr_status = res.data.saveQuestionRating.status;
                    }
                });
            },
            acceptAnswer() {
                this.$refs.question_accept.openDialog(this.question);
            },
            rejectAnswer() {
                this.$refs.question_reject.openDialog(this.question);
            },
            resubmitQuestion() {
                this.$refs.question_resubmit.openDialog(this.question);
            },
            deleteQuestion() {
                this.$refs.question_delete.openDialog(this.question);
            },
            preferredQuestions() {
                let route = this.$router.resolve({ path: "/task/customer_success/openai/std_questions/" + this.oavr_nr}); 
                window.open(route.href, "_blank");
            },
            updateAction(data, value) {
                switch (data) {
                    case "accepted":
                        this.$emit("updateView", 0);
                        break;
                
                    case "rejected":
                        this.$emit("updateView", 0);
                        break;

                    case "resubmit":
                        this.$emit("updateView", 0);
                        break;

                    case "delete":
                        this.$emit("updateView", 0);
                        break;

                    case "question_translation":
                        this.question_translation = value;
                        this.setupQuestion(false);
                        break;

                    case "answer_org_translation":
                        this.answer_org_translation = value;
                        this.setupAnswer(false);
                        break;

                    case "oavr_antwoord_def":
                        this.question.oavr_antwoord_def = value;
                        break;

                    default:
                        break;
                }                
            },
            toggleField() {
                this.hide = !this.hide;
                if (this.hide) {
                    this.hide_txt = "Show chatGPT";
                    this.hide_tip = "Show chatGPT answer";
                } else {
                    this.hide_txt = "Hide chatGPT";
                    this.hide_tip = "Hide chatGPT answer";                    
                }
            },
            // translate(toLanguage, fromValue, toField) {
            //     this.$axios.post("ares/json/ares/task/customer_success/openai/translateText.p", {
            //         header: {
            //             token: this.$session.get("ARES"),
            //             clientSessionId: this.$session.id(),
            //             request: "translateText"
            //         },
            //         translateText: {
            //             text: fromValue,
            //             toLanguage: toLanguage,
            //         }
            //     }).then(res => {
            //         if (res.data.error) {
            //             this.$store.dispatch("setSnackbar", {
            //                 showing: true,
            //                 text: res.data.error.message,
            //                 color: "error"
            //             });
            //         } else {
            //             this[toField] = res.data.translateText;
            //         }
            //     });
            // },
            showQuestion(newValue) {
                this.question_view_org = newValue;
                if (this.question_view_org) {
                    this.question.view = this.question.oavr_vraag;
                } else {
                    this.question.view = this.question_translation;
                }
            },
            saveRemark() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/saveQuestionRemark.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveQuestionRemark"
                    },
                    saveQuestionRemark: {
                        oavr_encrid: this.question.oavr_encrid,
                        oavr_opm_intern: this.question.oavr_opm_intern,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveQuestionRemark.text,
                            color: res.data.saveQuestionRemark.color
                        });
                        this.remark_copy = this.question.oavr_opm_intern;
                        this.remarkAction(false);
                    }
                });
            },
            undoRemark() {
                this.question.oavr_opm_intern = this.remark_copy;
            },
            remarkAction(hide_value) {
                this.remark_hide = hide_value;
                if (this.question.oavr_opm_intern === "") {
                    this.remark_txt = "Add remark";
                    this.remark_tip = "Add internal remark";
                    this.remark_color = "primary";
                } else {
                    this.remark_txt = "Show remark";
                    this.remark_tip = "Show/Edit internal remark";
                    this.remark_color = "warning";
                }
                if (!this.remark_hide) {
                    this.remark_txt = "Hide remark";
                    this.remark_tip = "Hide internal remark";
                }
            }
        }
    }
</script>

<style scoped> 
    .houvlink {
        cursor: pointer;
        text-decoration: underline;
        color: blue,
    }
</style>